import { render, staticRenderFns } from "./papContent.vue?vue&type=template&id=40c61bf1&scoped=true&"
import script from "./papContent.vue?vue&type=script&lang=js&"
export * from "./papContent.vue?vue&type=script&lang=js&"
import style0 from "./papContent.vue?vue&type=style&index=0&id=40c61bf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c61bf1",
  null
  
)

export default component.exports